
var totalAllowedQty = 5;
if (parseInt($(".added").html()) > 5) {
  totalAllowedQty = 10;
  $('.outofCount').html(totalAllowedQty); // mob-surpise
  $('.totalAllowedQty').html(totalAllowedQty); // mob-surpise
  $('.remaining').html(10-parseInt($(".added").html()));  // mob-surpise
}

// var surpriseProductID = 11589973441;
var surpriseProductID = 25387964675;
var surpriseProductImgURL= "//cdn.shopify.com/s/files/1/1404/4825/products/surprise_small.png?v=1470648915";
var tryOneBoxID = 25195437123;

function follow_Screen() {
  if($(window).width() >= 768) {
    var element_left = $('.follow-scroll-left'),
        originalY_left = element_left.offset().top;
    var element_right = $('.follow-scroll-right'),
        originalY_right = element_right.offset().top;

    // Space between element and top of screen (when scrolling)
    var topMargin = 20;

    // Should probably be set in CSS; but here just for emphasis
    element_left.css('position', 'relative');
    element_right.css('position', 'relative');

    $(window).on('scroll', function(event) {
      var scrollTop = $(window).scrollTop();
//       var nextPosition = scrollTop - originalY_right + topMargin;
//       var maxPositionAllowed = 4400;


      element_left.stop(false, false).animate({
        top: scrollTop < originalY_left
        ? 0
        : scrollTop - originalY_left + topMargin
      }, 300);

      element_right.stop(false, false).animate({
        top: scrollTop < originalY_right
        ? 0
        : scrollTop - originalY_right + topMargin  // Math.min(nextPosition, maxPositionAllowed) 
      }, 300);
    });
  }
  else {
 /*   var element_left = $('.follow-scroll-left');

    // Space between element and top of screen (when scrolling)
    var topMargin = 20;

    // Should probably be set in CSS; but here just for emphasis
    element_left.css('position', 'relative');

    $(window).on('scroll', function(event) {
      var scrollTop = $(window).scrollTop();
      if(scrollTop > 200) {
        element_left.css({ position: 'fixed', top: 0, left: 0, zIndex: '1000', width: "100%", padding: '2px 10px 2px 10px' });
      }
      else {
        element_left.removeAttr("style");
      }
    });*/
  }
}
(function($) {
  if($(window).width() < 769) {
    $("a.proceed").hide();
    $("a.proceed-mobile").hide();
  }
  $(".blury-container").show();
  $(".choose-snack").click(function() {
    // enable body scroll
    $('body').css('overflow-y', 'initial');
    $("#chosen-snack-type").val($(this).data("snacktype"));
    if($(this).data("snacktype") == "1") {
      add5Surprise();
    }
    else {
      follow_Screen();
    }
  });

  if($(window).width() < 768) {
    if($.cookie('dont-worries-popup') == undefined) {
      $("#dont-worries-mobile").fadeIn(500);
    }
     $(".ok-button").click(function() {
       // disable body scroll
       //$('body').css('overflow-y', 'hidden');
       
       $.cookie('dont-worries-popup', 'true', { expires: 7 });
       $("#dont-worries-mobile").fadeOut(500);
       // scroll to product-middle-part
       var target = $('.product-middle-part');
       if( target.length ) {
         event.preventDefault();
         $('html, body').stop().animate({
           scrollTop: target.offset().top - 20
         }, 500);
       }
     });
    $(".cancel-button").click(function() {
      $(this).closest(".are-you-sure").fadeOut(500);
    });
    
    
//     yes-button click functionality
    $('.yes-button').on("click", function checkLastClick (e) {
      var lastClicked = $(this).data("lastClicked") || 0;
      e.preventDefault();
      $('.yes-button').off("click", 'checkLastClick');
        if ( (new Date() - lastClicked >= 3500) || lastClicked == 0) {
          $(this).data("lastClicked", new Date());
          yesButtonClick();
        }
    });
    
    function yesButtonClick() {
      var surpriseQty = $.trim($(".remaining:first").html());
      $.post('/cart/add.js', {
        quantity: surpriseQty,
        id: surpriseProductID
      }, function(data) {
        var html = $("#cart_template").val();
        var img = data.image.split("/")[data.image.split("/").length -1];
        img = img.replace(".", "_large.");
        img = data.image.replace(data.image.split("/")[data.image.split("/").length -1], img);

        html = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title + " X " + surpriseQty).replace("#IMG#", img).replace("#QTYADDED#", surpriseQty);
        var isFound = false;
        $(".cart-right li").each(function() {
          if($(this).find(".added-cart").index() == -1 && !isFound) {
            $(html).insertAfter($(this).find(".note-pick"));
            $(this).find(".note-pick").hide();
            isFound = true;
          }
        });
        var totalItem = parseInt($(".added").html());
        totalItem = parseInt(totalItem) + parseInt(surpriseQty);
        $(".added").html(totalItem);
        $('.cart-items').text(totalItem);
        $(".remaining").html(parseInt(totalAllowedQty) - parseInt(totalItem));
        if(totalItem >= totalAllowedQty) {
          $(".suprise-click").hide();
          $(".are-you-sure").hide();
          $(".surprise-box").fadeOut(100, function() {
            $(".a-proceed-box, .schedule-box").fadeIn(100);
            if($(window).width() < 768) {
//               console.log(totalAllowedQty);
              if(totalAllowedQty == 5)
                window.location.href = "/products/get-your-snackbox-2";
              else
                addTryOneBox2Qty();
                
            }
          });
        }
      }, 'json');
    };
//  End yes-button click functionality
    $(".popup-cart, .cart-right .pick-a-snack, .surprise-box > .proceed-box").click(function() {
      
      if($(".product-right-part").is(":visible")) {
        $(".product-right-part").fadeOut(500);
      }
      else {
        $(".product-right-part").fadeIn(500);
      }
      
      $('.a-proceed-box.mobile-show-hard').toggleClass('z-1000');
      $('.a-proceed-box.mobile-show-hard .goto').toggleClass('v-hidden');
    });
  }
  
  // show added product as ADDED instead of ADD TO CART on Reload page
  $.getJSON("/cart.js", function(data){
    if(Object.keys(data.items).length > 0) {
      //alert(JSON.stringify(data.items));
        $.each(data.items, function(i, item){
            //alert(JSON.stringify(item.id));
          $('.middle-part-sec-2').find("[data-id='" + item.id + "']").addClass('active').val('Added');
        });
    }
  });
  
})(jQuery);

var lastPopupObj;
jQuery(document).ready(function() {
  
  // Check is page GYB
  if($(".product-body #snacktype-2-target").length) {
    console.log('GYB page');
  	back2GYB();
    loadFabbox1_2Items();
  }
  
  $(".cart-right li .title").each(function() {
    if($.trim($(this).html()) == "Mini Fab Box" || $.trim($(this).html()) == "Try One Box - Try One Box" || $.trim($(this).html()) == "3 Months Subscription" || $.trim($(this).html()) == "6 Months Subscription") {
      var obj = $(this);
      setTimeout(function() {
        obj.parent().find(".cart").trigger("click");
        window.location.reload();
      }, 1000);
    }
  });
  
// Empty cart Function
  
  $('.empty-cart').on('click',function(){
    console.log("totalAllowedQty: "+totalAllowedQty + " added : " +parseInt($(".added").html()));
    if(totalAllowedQty == 10 && parseInt($(".added").html()) != 0 ) {
      console.log('emptySingleBox called');
      emptySingleBox();
    }
    else {
      console.log('empty cart called');
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        async: false,
        cache: false,
        success: emptyCart,
        dataType: 'json'
      }); 
    }
    
  }); 
    
    function emptyCart(data){
      // Update totalAllowedQty & add_2nd_box_clicked
      totalAllowedQty = 5;
      $('.outofCount').html('5');
      $('.totalAllowedQty').html(totalAllowedQty);
      add_2nd_box_clicked = false;
      // Update added and remaining items count
       $('.follow-scroll-right .note .added').html('0');
       //$('.follow-scroll-right .note .remaining').html('5');
       $('.remaining').html('5');
      // For mobile
      $('.popup-cart .cart-items').html('0');
      // Update surprise popup added and remaining
      $('.surprise-popup .cart-items').html('0');
      $('.surprise-popup .remaining').html('5');
      
	  // Pick a snack note
       $('.cart-right .added-cart').each(function(){
            $(this).prev(".note-pick").removeClass('hide');
            $(this).remove();
        });
      // Remove Proceed button and show surprise and update suprise remaining item 
        $(".suprise-click").show().find('.remaining').html('5');
        $(".a-proceed-box, .schedule-box").fadeOut(100, function() {
          $(".surprise-box").fadeIn(100);
        });
      // Update Add To Box button
        $('.addtocart-custom-new.active').each(function() {
			$(this).removeClass('active').val('Add To Box');
        });
      
      // Remove extra li if present in fabbox-1
      if($('.cart-right.cart-right-fabbox-1 li').length > 5) {
        $('.cart-right.cart-right-fabbox-1 li').slice(5, $('.cart-right li').length).remove();
      }
      // Remove extra li if present in fabbox-1
      if($('.cart-right.cart-right-fabbox-2 li').length > 5) {
        $('.cart-right.cart-right-fabbox-2 li').slice(5, $('.cart-right li').length).remove();
      }
      
      // Show all the item <li>
        $(".note-pick").not(":visible").each(function() {
            $(this).closest("li").show();
          });
      
    // Empty cart function when fabbox-2 present
      $('.fabbox-1-text-wrap').addClass('hide');	// hide fabbox-1-text
      $('.cart-right-fabbox-1 li').removeClass('hide');	// display fabbox-1 li
      $('.fabbox-1-proceed').removeClass('hide');
      $('.cart-right-fabbox-2').addClass('hide');
      
      // update or, and text display of fabbox-2
      $('.add-2nd-box-wrap .or').addClass('hide');
      $('.add-2nd-box-wrap .and').addClass('hide');
      
    // clear StroeFabboxItemsInfo
      clearStroeFabboxItemsInfo();
      
   }
  
  
  /* Step 1 Start */
  
//   Add to cart function
  
  $('.addtocart-custom-new').on("click", function test (e) {
    var lastClicked = $(this).data("lastClicked") || 0;
	e.preventDefault();
	$('.addtocart-custom-new').off("click", 'test');
	  if ( (new Date() - lastClicked >= 3500) || lastClicked == 0) {
        $(this).data("lastClicked", new Date());
		addToCart($(this));
	  }
});
  
  function addToCart (ele) {
  	if(parseInt($(".added").html()) < totalAllowedQty) {
      console.log("added");
      var id = ele.data("id");
      var object = ele;
      var itemTitle = '';
      var addToItemQTY = '';
      $.post('/cart/add.js', {
        quantity: 1,
        id: id
      }, function(data) {
        var html = $("#cart_template").val();
        var img = data.image.split("/")[data.image.split("/").length -1];
        img = img.replace(".", "_large.");
        img = data.image.replace(data.image.split("/")[data.image.split("/").length -1], img);
        itemTitle = data.product_title;
        addToItemQTY = data.quantity;
        
        html = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title).replace("#IMG#", img).replace("#QTYADDED#", "1");
        var isFound = false;
        object.addClass("active");
        object.val("Added");
       
        var makeVisibleBox ;
        var fabbox1HasEmptyLi = false;
        
        $(".product-right-part .cart-right li").each(function() {
          if($(this).find(".added-cart").index() == -1 && !isFound) {
            // set fabbox1HasEmptyLi if fabbox1 has empty li
            if ($(this).parents('.cart-right').hasClass('cart-right-fabbox-1')) {
              fabbox1HasEmptyLi = true;
            }
            // End set fabbox1HasEmptyLi if fabbox1 has empty li
            
            $(html).insertAfter($(this).find(".note-pick"));
            $(this).find(".note-pick").addClass('hide');
            
            isFound = true;
          }
        });
        
        
        // Make visible first empty li box
        console.log('fabbox1HasEmptyLi: '+ fabbox1HasEmptyLi);
        if(fabbox1HasEmptyLi) {
          if($('.cart-right-fabbox-1 li').hasClass('hide')) {
            $('.cart-right-fabbox-1 .fabbox-1-text').click();
            console.log('.fabbox-1-text click triggered:');
           }
        }
        else {
          if($('.cart-right-fabbox-2 li').hasClass('hide')) {
            $('.cart-right-fabbox-2 .fabbox-2-text').click();
            console.log('.fabbox-2-text click triggered:');
           }
        }
        // End Make visible first empty li box
        
        var totalItem = parseInt($(".added").html());
        totalItem++;
        $(".added").html(totalItem);
        $('.cart-items').text(totalItem);
        $(".remaining").html(totalAllowedQty - totalItem);
        if(totalItem >= totalAllowedQty) {
          $(".suprise-click").hide();
          $(".surprise-box").fadeOut(100, function() {
            $(".a-proceed-box ,.schedule-box").fadeIn(100);
          });
        }
        
// 		var makeVisibleBox ;
//         var fabbox1HasEmptyLi = false;
//         $('.product-right-part .cart-right li').each(function() {
//           if ($(this).find(".added-cart").index() == -1){
//             if ($(this).parents('.cart-right').hasClass('cart-right-fabbox-1')) {
//               makeVisibleBox = $('.cart-right-fabbox-1');
//               fabbox1HasEmptyLi = true;
//             }
//             else {
//               makeVisibleBox = $('.cart-right-fabbox-2');
//             }
//             return false;
//           }   
//         });
//         console.log('fabbox1HasEmptyLi: '+ fabbox1HasEmptyLi);
//         if (makeVisibleBox.find('li').hasClass('hide')) {
//         	makeVisibleBox.find('div>a.btn').click();
//         }
          
        
        var addedItems = [];
        var addToItemId = id;
        
        // Fabbox-1 add product function
        if(totalAllowedQty == 5 || fabbox1HasEmptyLi) {
          $('.product-right-part .cart-right-fabbox-1 div.added-cart').each(function() {
            addedItems.push($(this).data('id'));
          });
          
          if( addedItems.indexOf(addToItemId) != -1 ) {
            var $ele = $(".product-right-part .cart-right-fabbox-1 div.added-cart[data-id='" + addToItemId + "']:first");
            console.log('addToItemQTY: ' + addToItemQTY);
            
            // check item present in fabbox-2 and update addToItemQTY
            var $elebox2 = $(".product-right-part .cart-right-fabbox-2 div.added-cart[data-id='" + addToItemId + "']:first");
            if( $elebox2.length) {
              console.log('item present in box2');
              var box2Qty = parseInt($elebox2.find('a.cart.remove').data('qty'));
              addToItemQTY = addToItemQTY-box2Qty;
              console.log(box2Qty);
              console.log('box2-qty: ' + box2Qty);
              console.log('addToItemQTY: ' + addToItemQTY);
            }
            
            
            if(addToItemQTY > 1) {
              $ele.find('.title').html(itemTitle + ' <span class="item-multi"> X </span> <span class="item-title-qty">' + addToItemQTY + '</span>' );
              $ele.find('.cart.remove').attr('data-qty', addToItemQTY);
            }

            $(".product-right-part .cart-right-fabbox-1 div.added-cart[data-id='" + addToItemId + "']:not(:first)").prev().addClass('hide');
            $(".product-right-part .cart-right-fabbox-1 div.added-cart[data-id='" + addToItemId + "']:not(:first)").parent('li').hide();          
            
          }
        } 
        // Fabbox-2 add product function
        else {
          $('.product-right-part .cart-right-fabbox-2 div.added-cart').each(function() {
            addedItems.push($(this).data('id'));
          });

          if( addedItems.indexOf(addToItemId) != -1 ) {
            var $ele = $(".product-right-part .cart-right-fabbox-2 div.added-cart[data-id='" + addToItemId + "']:first");
            console.log('addToItemQTY: ' + addToItemQTY);
            // check item present in fabbox-1 and update addToItemQTY
            var $elebox1 = $(".product-right-part .cart-right-fabbox-1 div.added-cart[data-id='" + addToItemId + "']:first");
            if( $elebox1.length) {
              console.log('item present in box1');
              var box1Qty = parseInt($elebox1.find('a.cart.remove').data('qty'));
              addToItemQTY = addToItemQTY-box1Qty;
//               console.log(box1Qty);
//               console.log('box1-qty: ' + box1Qty);
//               console.log('box-2-qty: ' + addToItemQTY-box1Qty);
            }

            if(addToItemQTY > 1) {
              $ele.find('.title').html(itemTitle + ' <span class="item-multi"> X </span> <span class="item-title-qty">' + addToItemQTY + '</span>' );
              $ele.find('.cart.remove').attr('data-qty', addToItemQTY);
            }

            $(".product-right-part .cart-right-fabbox-2 div.added-cart[data-id='" + addToItemId + "']:not(:first)").prev().addClass('hide');
            $(".product-right-part .cart-right-fabbox-2 div.added-cart[data-id='" + addToItemId + "']:not(:first)").parent('li').hide();          
          }
          
        }
        
        // show added item as alert fade popup
       var triangleup = $(".triangle-up");
		var mobileCartContainer = $(".mobile-cart-container");
            mobileCartContainer.html("");
            mobileCartContainer.html($(".product-right-part .cart-right").clone());
        	mobileCartContainer.append('<div class="triangle-up"> <div class="inner-triangle"></div> </div>');
            $(".mobile-cart-container li").each(function() {
              if($(this).find(".added-cart").index() == -1)
                $(this).remove();
            });
        	mobileCartContainer.fadeIn();
        	setTimeout(function(){ mobileCartContainer.fadeOut(800); }, 2000);
        // End

      }, 'json');
    }
    else {
      alert("Oops! you have already chosen "+totalAllowedQty+" items.");
    }
    
  }
  
// 
  
  
// Let it be surprise functionality  
  $('.let-surprise').click(function() {
      console.log('.let-surprise clicked');
    if(parseInt($(".added").html()) < totalAllowedQty) {
//       var id = "11589973441"
      var id = surpriseProductID;
      $.post('/cart/add.js', {
          quantity: 1,
          id: id
      }, function(data) {
      	var html = $("#cart_template").val();
        var img = data.image.split("/")[data.image.split("/").length -1];
        img = img.replace(".", "_large.");
        img = data.image.replace(data.image.split("/")[data.image.split("/").length -1], img);
        
        html = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title).replace("#IMG#", img).replace("#QTYADDED#", "1");
        var isFound = false;
        
        $(".cart-right li").each(function() {
          if($(this).find(".added-cart").index() == -1 && !isFound) {
            $(html).insertAfter($(this).find(".note-pick"));
            $(this).find(".note-pick").addClass('hide');
            isFound = true;
          }
        });
        
        
        var addedEle = $(".added");
        var remainEle = $(".remaining");
        var addedItems = parseInt(addedEle.html());
        var remainItems = parseInt(remainEle.html());
        var updatedAddedItems = addedItems+1;
        var updatedRemainItems = remainItems-1;
        
        // Update added and remaining items count
        addedEle.html(updatedAddedItems);
        remainEle.html(updatedRemainItems);
        // for mobile
      	$('.popup-cart .cart-items').html(updatedAddedItems);
    	$('.surprise-popup .cart-items').html(updatedAddedItems);
        
//         var totalItem = parseInt($(".added").html());
//         totalItem++;
//         $(".added").html(totalItem);
//         $('.cart-items').text(totalItem);
//         $(".remaining").html(totalAllowedQty - totalItem);
        if(updatedAddedItems >= totalAllowedQty) {
          $(".suprise-click").hide();
          $(".surprise-box").fadeOut(100, function() {
            $(".a-proceed-box, .schedule-box").fadeIn(100);
          });
        }
		
      }, 'json');

  	}
  });
  
  
  $(".cart-right").on("click", ".remove", function() {
    
    var objRemove = $(this).closest(".added-cart");
    var isFabbox2 = $(this).parents('.cart-right').hasClass('cart-right-fabbox-2');
    console.log('isFabbox2: ' + isFabbox2);
    
    var addedEle = $(".added");
    var remainEle = $(".remaining");
    var addedItems = parseInt(addedEle.html());
    var remainItems = parseInt(remainEle.html());
    var updatedAddedItems = addedItems-1;
    var updatedRemainItems = remainItems+1;

    var itemQTY = parseInt($(this).data('qty'));
    var removeIndex = $(this).closest("li").index();
    var removeItemId = objRemove.data('id');
    var updatedItemQTY = itemQTY-1;
    
    
    if( itemQTY > 1 && removeItemId != surpriseProductID ) {
      // Update data-dty 
      $(this).data('qty', updatedItemQTY); // it will update data value but wont reflect in html
      
      // Update current Pick a box li - title qty
      if (updatedItemQTY == 1) 
        objRemove.find('.item-title-qty , .item-multi').html('');
      else 
        objRemove.find('.item-title-qty').html(updatedItemQTY);
      
      // Update Pick a box li - show one more pick a box
      if (isFabbox2)
        var pickBox = $(".follow-scroll-right .cart-right-fabbox-2 .added-cart[data-id='" + removeItemId + "']:last");
      else
      	var pickBox = $(".follow-scroll-right .cart-right-fabbox-1 .added-cart[data-id='" + removeItemId + "']:last");
      	pickBox.parent('li').show();
        pickBox.prev('.note-pick').removeClass('hide');
        pickBox.remove();
  	}
    
    else if (itemQTY > 1 && removeItemId == surpriseProductID) {
      // Remove item from pick a box 
      objRemove.prev(".note-pick").removeClass('hide');
      objRemove.remove();
      if (isFabbox2)
        var ele_li_hidden = $('.follow-scroll-right .cart-right-fabbox-2 li:hidden');
      else
        var ele_li_hidden = $('.follow-scroll-right .cart-right-fabbox-1 li:hidden');
      ele_li_hidden.each(function() {
        if($(this).find('.added-cart').length == 0){
        	$(this).show();
        }
        else if($(this).find('.added-cart').data('id') == surpriseProductID) {
        	$(this).find('.added-cart').remove();
          	$(this).find('.note-pick').removeClass('hide');
          	$(this).show();
        }
      });
    }
    else {
      // Remove item from pick a box 
      	objRemove.prev(".note-pick").removeClass('hide');
    	objRemove.remove();
    }
    
    if (removeItemId != surpriseProductID) {
   	  // Update added and remaining items count
        addedEle.html(updatedAddedItems);
        remainEle.html(updatedRemainItems);
      // for mobile
      	$('.popup-cart .cart-items').html(updatedAddedItems);
    	$('.surprise-popup .cart-items').html(updatedAddedItems);
    }
    else {
      // Update added and remaining items count
        addedEle.html(addedItems-itemQTY);
        remainEle.html(remainItems+itemQTY);
      // for mobile
      	$('.popup-cart .cart-items').html(addedItems-itemQTY);
    	$('.surprise-popup .cart-items').html(addedItems-itemQTY);
    }

//     var objThis = $(this);
       
    // Update Proceed button and show surprise and update suprise remaining item 
      if(updatedAddedItems < totalAllowedQty) {
        $(".suprise-click").show();
        $(".a-proceed-box , .schedule-box").fadeOut(100, function() {
          $(".surprise-box").fadeIn(100);
        });
      }
    
    // Update updatedItemQTY to remove the qty from shopify cart
    var otherBoxEle;
    var otherBoxQTY;
    if(isFabbox2) 
      otherBoxEle = $(".product-right-part .cart-right-fabbox-1 div.added-cart[data-id='" + removeItemId + "']:first");
    else 
      otherBoxEle = $(".product-right-part .cart-right-fabbox-2 div.added-cart[data-id='" + removeItemId + "']:first");
    
    if(otherBoxEle.length) {
      otherBoxQTY = parseInt(otherBoxEle.find('a.cart.remove').data('qty'));
      updatedItemQTY = updatedItemQTY + otherBoxQTY;
    }
    
    // Remove Item from shopify cart and Update Add To Box button
    var removeItemURL = $(this).data("href");
    if(removeItemId != surpriseProductID) // not surprise pack
      removeItemURL = removeItemURL.replace("=0", "="+parseInt(updatedItemQTY));
    else if(itemQTY == 1 && removeItemId == surpriseProductID) {
      var remainSurpriseCount = $(".follow-scroll-right .added-cart[data-id='" + removeItemId + "']").length;
      removeItemURL = removeItemURL.replace("=0", "="+parseInt(remainSurpriseCount));
    }
    else if(itemQTY > 1 && removeItemId == surpriseProductID) { 
      if(isFabbox2)
      	var remainSurpriseCount = $(".follow-scroll-right .cart-right-fabbox-1 .added-cart[data-id='" + removeItemId + "']").length;
      else 
        var remainSurpriseCount = $(".follow-scroll-right .cart-right-fabbox-2 .added-cart[data-id='" + removeItemId + "']").length;
    	removeItemURL = removeItemURL.replace("=0", "="+parseInt(remainSurpriseCount));
    }
    
    console.log('removeItemURL: '+ removeItemURL);
    $.get(removeItemURL, function() {
      // Update Add to Box button
      var addedItems = [];

      $('.follow-scroll-right .cart-right div.added-cart').each(function() {
        addedItems.push($(this).data('id'));
      });

      if( addedItems.indexOf(removeItemId) == -1 ) {
        $("[data-id='" + removeItemId + "']").removeClass('active').val('Add To Box');
      }
    });
  
  });
  
  
  $(".follow-scroll-left ul li a").click(function() {
    $(".follow-scroll-left ul li a").removeClass("active");
    $(this).addClass("active");
  });
  $(".animation-zoom").click(function() {
    lastPopupObj = $(this).data("href");
    var url = $($(this).data("href")).data("url");
    var objInner = this;
    $(".description-div").html("");
    
    $($(this).data("href") + " .product-description").load(url + " .description-div", function() {
      if($.trim($(".description-div").find(".description").html()) == "") {
        $(".description-div").html("<h4 style='margin-top: 10px; text-align: center;'>Oops! No additional information found.</h4>");
        $(".description-div").removeClass("span6");
        $($(objInner).data("href") + "_bg").show();
        $($(objInner).data("href")).show();
        var height = $($(objInner).data("href")).outerHeight();
        var width = $($(objInner).data("href")).outerWidth();
        height = height/2;
        width = width/2;
        $($(objInner).data("href")).attr("style", "margin-left: -" + width + "px ;margin-top: -" + height + "px");
      }
      else {
       
      
        //$(".description-div h1.title").remove();
        $(".description-div").find("a.btn:first").remove();
        $(".description-div .social-sharing").parent().remove();
        
        $(".description-div").removeClass("span6");
        
        $(".description-div").css("text-align", "center");
        $(".description-div p").addClass("adjust-description-p");

        $($(objInner).data("href") + "_bg").show();
        $($(objInner).data("href")).show();
        var height = $($(objInner).data("href")).outerHeight();
        var width = $($(objInner).data("href")).outerWidth();
        height = height/2;
        width = width/2;
        $($(objInner).data("href")).attr("style", "margin-left: -" + width + "px ;margin-top: -" + height + "px");
      }
    });
  });
  $(".closePopup, .nutrition-table-closePopup").click(function() {
    $(lastPopupObj + "_bg").hide();
    $(lastPopupObj).hide();
    lastPopupObj = "";
  });
  /* Step 1 End */
  
  /* Step 2 Start */
    
  $('.suprise-click').on("click", function checkLastClick (e) {
    var lastClicked = $(this).data("lastClicked") || 0;
	e.preventDefault();
	$('.suprise-click').off("click", 'checkLastClick');
	  if ( (new Date() - lastClicked >= 3500) || lastClicked == 0) {
        $(this).data("lastClicked", new Date());
		supriseClick();
	  }
  });
  
  
//   $(".suprise-click").click();
  function supriseClick() {
    if($(window).width() < 767) {
      $('.cust-blur.GYB-bg-blur').removeClass('hide').css({'background-color': 'rgba(0,0,0,0.7)','z-index': '1001' });
      $(".are-you-sure").fadeIn(500);
    }
    else {
      var surpriseQty = $.trim($(".remaining:first").html());
      $.post('/cart/add.js', {
        quantity: surpriseQty,
          id: surpriseProductID
      }, function(data) {
        var html = $("#cart_template").val();
        var img = data.image.split("/")[data.image.split("/").length -1];
        img = img.replace(".", "_large.");
        img = data.image.replace(data.image.split("/")[data.image.split("/").length -1], img);
                
        // scenario (fabbox-1)- adding surprise item when fabbox-1 having empty li
        var fabbox2Visible = $('.cart-right-fabbox-2').is(':visible');
        var fabbox1added_li = $('.follow-scroll-right .cart-right-fabbox-1 .added-cart').length;
        var fabbox2added_li = $('.follow-scroll-right .cart-right-fabbox-2 .added-cart').length;
        var fabbox1Empty_li = 5 - fabbox1added_li ;
        var fabbox2Empty_li = 5 - fabbox2added_li ;
//         console.log(fabbox2Visible);
//         console.log(fabbox1added_li);
//         console.log(fabbox2added_li);
        
        if( Boolean(fabbox2Visible) && Boolean(fabbox1added_li < 5) && Boolean(fabbox1added_li < 5 ) ) {
          // For Fabbox-1
          var fabbox1surpriseQty = fabbox1Empty_li;
          var html_1 = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title + " X " + fabbox1surpriseQty).replace("#IMG#", img)
          		.replace("#QTYADDED#", fabbox1surpriseQty);
//           console.log(fabbox1surpriseQty);
//           console.log('fabbox-1');
//           console.log(html_1);
          
          var isFound = false;
          var surprise_i = fabbox1surpriseQty-1;
          $(".cart-right-fabbox-1 li").each(function() {
            if($(this).find(".added-cart").index() == -1) {
              if(!isFound) {
                isFound = true;
                $(html_1).insertAfter($(this).find(".note-pick"));
                $(this).find(".note-pick").addClass('hide');
              } else {
                if(surprise_i > 0) {
                  surprise_i--;
                  $(html_1).insertAfter($(this).find(".note-pick"));
                  $(this).hide();
                }
              }
            }
          });
          
          // For Fabbox-2
          var fabbox2surpriseQty = surpriseQty - fabbox1surpriseQty;
          var html_2 = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title + " X " + fabbox2surpriseQty).replace("#IMG#", img)
          		.replace("#QTYADDED#", fabbox2surpriseQty);
          console.log(fabbox2surpriseQty);
          console.log('fabbox-2');
          console.log(html_2);
          var isFound = false;
          var surprise_i = fabbox2surpriseQty-1;
          $(".cart-right-fabbox-2 li").each(function() {
            if($(this).find(".added-cart").index() == -1) {
              if(!isFound) {
                isFound = true;
                $(html_2).insertAfter($(this).find(".note-pick"));
                $(this).find(".note-pick").addClass('hide');
              } else {
                if(surprise_i > 0) {
                  surprise_i--;
                  $(html_2).insertAfter($(this).find(".note-pick"));
                  $(this).hide();
                }
              }
            }
          });
        
        }
        else { // normal 
          console.log('normal');
          html = html.replace("#itemID#", data.id).replace("#ID#", data.id).replace("#TITLE#", data.product_title + " X " + surpriseQty).replace("#IMG#", img).replace("#QTYADDED#", surpriseQty);
          var isFound = false;
          var surprise_i = surpriseQty-1;
          $(".cart-right li").each(function() {
            if($(this).find(".added-cart").index() == -1) {
              if(!isFound) {
                isFound = true;
                $(html).insertAfter($(this).find(".note-pick"));
                $(this).find(".note-pick").addClass('hide');
              } else {
                if(surprise_i > 0) {
                  surprise_i--;
                  $(html).insertAfter($(this).find(".note-pick"));
                  $(this).hide();
                }
              }
            }
          });
        }
        
        
        
        var totalItem = parseInt($(".added").html());
        totalItem = parseInt(totalItem) + parseInt(surpriseQty);
        $(".added").html(totalItem);
        $('.cart-items').text(totalItem);
        $(".remaining").html(parseInt(totalAllowedQty) - parseInt(totalItem));
        if(totalItem >= totalAllowedQty) {
//         if(totalItem == totalAllowedQty) {
          $(".suprise-click").hide();
          $(".surprise-box").Out(100, function() {
            $(".a-proceed-box, .schedule-box").fadeIn(100);
          });
        }
        $(".note-pick:visible").each(function() {
          $(this).closest("li").hide();
        });
      }, 'json');
    }
  };	// End suprise-click
  
  
  $("body.product-body a.proceed").click(function() {
    if($("#chosen-snack-type").val() == "1") {
      $(".suprise-click:first").click();
      if($(window).width() > 767) {
      	window.location.href = "/products/get-your-snackbox-2";
      }
    }
    else {
      try {
        $.removeCookie("order_note");
      }
      catch(e) { }
      
      if($.trim($("#note").val()) != "")
          $.cookie("order_note", $.trim($("#note").val()), { path: '/', expires: 1 });
      
      // check fabbox 1 or 2 Proceed btn
      if($(this).hasClass('fabbox-2-proceed')) {
        addTryOneBox2Qty();
      }
      else{
      	window.location.href = "/products/get-your-snackbox-2";
      }
      
    }
    /* $("#step-1").hide();
    $("#step-3").hide();
    $("#step-2").show();
    
    $("#get_your_box_container").load("/pages/step-2 #step_2", function() {
      var body = $("html, body");
      body.stop().animate({scrollTop:0}, '500', 'swing');
    }); */
  });
  $("a.proceed-mobile").click(function() {
    var addedCount = parseInt($(".added:first").html());
    if( addedCount != totalAllowedQty) {
      $(".suprise-click").click();
    }
    else {
      if(addedCount == 10) { 
		addTryOneBox2Qty();
      }
      else {
        window.location.href = "/products/get-your-snackbox-2";
      }
    }
  });
  /* Step 2 End */
  if($(window).width() < 768) {
    $(".goto").click(function() {
      if($(".goto-body").is(":visible")) {
        $(".goto-body").fadeOut(500);
        $(".goto").find("i").removeClass("fa-arrow-circle-o-down").addClass("fa-arrow-circle-o-up");
      }
      else {
        $(".goto-body").fadeIn(500);
        $(".goto").find("i").removeClass("fa-arrow-circle-o-up").addClass("fa-arrow-circle-o-down");
      }
    });
    $(".goto-body a").click(function() {
      $(".goto").click();
    });
  }
  
  // Redirection On click dont-worries-mobile popup
  $('.dont-worries-mobile .yes-button').click( function(){
//     window.location.href = "/products/get-your-snackbox-2";
  });
  
  
//   Change next into proceed when 5 items in cart
  //   call while load
  next2proceed ();
  
  //   call while update cart
  $('.popup-cart > .cart-items').bind("DOMSubtreeModified",function(){
    next2proceed ();
  });
  
  function next2proceed () {
    var $ele = $('.popup-cart > .cart-items');
    var $itemCount = parseInt($ele.html());
    if($itemCount == totalAllowedQty) {
      $('a.proceed-mobile.next').html('Proceed >');
    }
    else {
      $('a.proceed-mobile.next').html('Next');
    }
    // hide add 2nd box btn - 
    if(totalAllowedQty == 10) {
      if($itemCount != totalAllowedQty) {
        $('.add-2nd-box').addClass('hide');
      }
    }
  }
  
  
  
// GYB - Add 2nd box functionality
// ----------------------------------------------- //
  
  // add-2nd-box click function
  var add_2nd_box_clicked = false;
  $('.add-2nd-box').click(function() {
    add_2nd_box_clicked = true;
    // Upadte totalAllowedQty & remaining qty & out of count values
    totalAllowedQty = 10;
    $('.remaining').html('5');
    $('.outofCount').html('10');
    $('.totalAllowedQty').html(totalAllowedQty);
    
    
    $(this).addClass('hide');
    $('.add-2nd-box-wrap .or').addClass('hide');
    $('.add-2nd-box-wrap .and').removeClass('hide');
  	$('.cart-right-fabbox-2').removeClass('hide');
    $('.fabbox-1-text-wrap').removeClass('hide');
    // hide the fabbox 1 li
    $('.cart-right-fabbox-1 li').addClass('hide');
    $('.cart-right-fabbox-1 ~ .a-proceed-box').css('display', 'none');
    // Show box-2
    $('.fabbox-2-text').click();
    
    // Display surprise-box div
    $('.surprise-box, .surprise-box > .suprise-click').css('display', 'block');
    
  	// mob-view 
    if ($('a.proceed-mobile.next').is(':visible')) {
    	$('a.proceed-mobile.next').html('Next');
    }
  });
  
  // fabbox-1-text & 2 btn click function
//   $('.fabbox-1-text, .fabbox-2-text').click(function() {
//   	$('.cart-right-fabbox-1 li').toggleClass('hide');
//     $('.cart-right-fabbox-2 li').toggleClass('hide');
// //     $('.cart-right-fabbox-1 li, .cart-right-fabbox-2 li').fadeToggle("slow");
// //     $('.fabbox-1-proceed').removeClass('hide');
//   });

  // fabbox-1-text btn click function
  $('.fabbox-1-text').click(function() {
    if(!$(this).hasClass('disabled')) {
      if($('.cart-right-fabbox-1 li').hasClass('hide')) {
          $('.cart-right-fabbox-1 li').removeClass('hide');
          $('.cart-right-fabbox-2 li').addClass('hide');
          $('.fabbox-1-text-icon').html('-');
          $('.fabbox-2-text-icon').html('+');
      }
      else {
          $('.cart-right-fabbox-2 li').removeClass('hide');
          $('.cart-right-fabbox-1 li').addClass('hide');
          $('.fabbox-1-text-icon').html('+');
          $('.fabbox-2-text-icon').html('-');
      }
    }
    else
      console.log('disabled');  
  });
 // fabbox-2-text btn click function
  $('.fabbox-2-text').click(function() {
    if(!$(this).hasClass('disabled')) {
      if($('.cart-right-fabbox-2 li').hasClass('hide')) {
          $('.cart-right-fabbox-2 li').removeClass('hide');
          $('.cart-right-fabbox-1 li').addClass('hide');
          $('.fabbox-2-text-icon').html('-');
          $('.fabbox-1-text-icon').html('+');
      }
      else {
          $('.cart-right-fabbox-1 li').removeClass('hide');
          $('.cart-right-fabbox-2 li').addClass('hide');
          $('.fabbox-2-text-icon').html('+');
          $('.fabbox-1-text-icon').html('-');
      }
    }
    else
      console.log('disabled');
  });
  
  
  // visible or hide the fabbox-1 proceed btn
//   var custI = 0;
  $('.added').bind("DOMSubtreeModified",function(){
//     alert($(".added").html() + $('.add-2nd-box-wrap').is(':visible'));
   	if(parseInt($(".added").html()) > 4) {
      $('.add-2nd-box-wrap').removeClass('hide');
      // Display +add 2nd box btn only if fabbox-2 not visible
      if(!add_2nd_box_clicked)
      	$('.add-2nd-box').removeClass('hide');
    }
    else {
      $('.add-2nd-box').addClass('hide');
//       if(!add_2nd_box_clicked)
      if(totalAllowedQty != 10)
      	$('.add-2nd-box-wrap').addClass('hide');
    }
    
    // update the display of fabbox-1-proceed btn
    if(add_2nd_box_clicked)
      $('.fabbox-1-proceed').addClass('hide');
    
    // update the display of fabbox-2-proceed btn
    if(parseInt($(".added").html()) == 10) {
      $('.fabbox-2-proceed').removeClass('hide');
      $('.fabbox-1-proceed').addClass('hide'); // reload-fix
      $('.add-2nd-box').addClass('hide'); // reload-fix
    }
    else
      $('.fabbox-2-proceed').addClass('hide');
    
//     custI = custI + 1;
//     if(custI%2 === 0) {
//     Store fabbox items info
      if($('.cart-right-fabbox-1 li').is(':visible'))
          setTimeout(stroeFabbox1ItemsInfo, 1500);
      if($('.cart-right-fabbox-2 li').is(':visible'))
          setTimeout(stroeFabbox2ItemsInfo, 1500);
//     }
    
  });

 
// END GYB - Add 2nd box functionality
// ----------------------------------------------- //
  
  
//   customers-order-body get your box functionality
  
//   Live
//   var $appAjaxURL = "/apps/fabbox/ajax.php";
//   Staging
  var $appAjaxURL = "/apps/fabbox-app-staging/ajax.php";
  
$('.customers-order-body .product-right-part a.proceed').click(function() {
  	$('body').append('<div class="preloader"> <div class="spinner-wrap"><i class="fa fa-spinner fa-pulse fa-fw"></i></div> <div>');
  	
  	var $parent_orderID = $('.order-title').data('parent_order_id');
  	var $scheduleDate = $('#schedule-order-datepicker').val() ? $('#schedule-order-datepicker').val() : '';
    
  	var $line_items = [];
  	$.getJSON("/cart.js", function(data){
      if(Object.keys(data.items).length > 0) {
          $.each(data.items, function(i, item){
//             alert(JSON.stringify(item.variant_id +':'+ item.quantity));
            var $obj = [];
            $obj.push(item.variant_id);
            $obj.push(item.quantity);
            $line_items.push($obj);
          });
      }
      
      var data = "action=next_month_subscription_order&parent_orderID="+$parent_orderID+"&line_items="+$line_items+"&scheduleDate="+$scheduleDate;
      console.log(data);
      $.post($appAjaxURL, data, function(data, status) {
        console.log(data);
        console.log(data.mainData);
//         $('.preloader').remove();
        $('body .preloader').html('<div class="alert alert-success alert-fixed-top alert-box-order fade in"> <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a> <strong>Success! </strong> Your order ('+ data.mainData +') has been placed successfully! </div>')
        $('.empty-cart').click();
      });	// End of post ajax
      
  	});	// End of cart.js ajax
  
  });	// End of customer-order-page proceed btn
  
	$('body.customers-order-body').on('click', '.alert .close', function(){
// 		$('.preloader').remove();
      
      	var firstEmptybox = $('.empty-box').first().attr('id');
      	var hashBox = firstEmptybox.substring(firstEmptybox.indexOf('box'), firstEmptybox.length);
      // Reload the page to new box
      	var reloadURL = location.toString();
        if(location.hash) {
          reloadURL = reloadURL.split('#');
          reloadURL = reloadURL[0];
        }
      	window.location = reloadURL+'#'+hashBox;
      	location.reload();
	});
  
//   createNoteTryOneBox2();
  clearNoteTryOneBox2();
       
});
   
    
// Function definitions
function addTryOneBox2Qty() {
  $.post('/cart/add.js', {
    quantity: 2,
    id: tryOneBoxID
  }, function(data) {
    createNoteTryOneBox2();
    window.location.href = "/cart";
  }, 'json');
}

function createNoteTryOneBox2() {
  var fabbox = [];
  var fabbox1 = [];
  var fabbox2 = [];
  
  if($(window).width() < 768) {
    if (!$('.cart_fancy').is(':visible') ){
      $('.popup-cart').click();
    }
  }
    
  
  // Get Fabbox-1 info 
  if($('.cart-right-fabbox-1 li').hasClass('hide')) // make visible to read data
    $('.fabbox-1-text').click();
  
  $('.cart-right-fabbox-1 li:visible').each(function() {
  	fabbox1.push($(this).find('.added-cart .title').text().trim());
  });
//   alert( fabbox1.join(','));
  fabbox.push('Fabbox-1: ' + fabbox1.join(','));
  
  // Get Fabbox-1 info 
  if($('.cart-right-fabbox-2 li').hasClass('hide'))  // make visible to read data
  	$('.fabbox-2-text').click();
  
  $('.cart-right-fabbox-2 li:visible').each(function() {
  	fabbox2.push($(this).find('.added-cart .title').text().trim());
  });
//   alert( fabbox2.join(','));
  fabbox.push('Fabbox-2: ' + fabbox2.join(','));
  localStorage.NoteTryOneBox2 = fabbox.join(';  ');
//   alert( localStorage.NoteTryOneBox2);
}
function clearNoteTryOneBox2() {
  localStorage.removeItem('NoteTryOneBox2');
}

//   var itemTitle = [];
//   var itemQty = [];
//   $('.added').bind("DOMSubtreeModified",function(){
//     var executed = false;
//    	console.log('changed');
//     var itemTitle = [];
//   	var itemQty = [];
//     if( !executed ) {
//       executed = true;
//       $('.cart-right-fabbox-1 li .added-cart:visible').each(function() {
//           var tempTitle = $(this).find('.title').text();
//           var tempQty = $(this).find('.cart.remove').data('qty');
//           itemTitle.push(tempTitle);
//           itemQty.push(tempQty);
//       });
//       console.log(itemTitle);
//       console.log(itemQty);
//     }
//   });


// Fabbox 1 item info
function stroeFabbox1ItemsInfo() {
  var fabbox1ItemsInfo = [];
  var fabbox1ItemsId = [];
  var fabbox1ItemsQty = [];
  $('.cart-right.cart-right-fabbox-1 div.added-cart:visible').each(function() {
    var tempId = $(this).data('id');
    var tempQty = $(this).find('.title').text();
    var indexOfQty = tempQty.indexOf(' X ');
    
    if (indexOfQty != -1) {
    	if (tempId == surpriseProductID)
          tempQty = tempQty.charAt(indexOfQty+3);
      	else
          tempQty = tempQty.charAt(indexOfQty+4);
    }
    else
      tempQty = 1;
    
    fabbox1ItemsInfo.push(tempId + ':' + tempQty );
    fabbox1ItemsId.push(tempId);
    fabbox1ItemsQty.push(tempQty);
  });
  console.log('addedItems1: ' + fabbox1ItemsInfo);
  localStorage.fabbox1ItemsId = fabbox1ItemsId;
  localStorage.fabbox1ItemsQty = fabbox1ItemsQty;

}

// Fabbox 2 item info
function stroeFabbox2ItemsInfo() {
  var fabbox2ItemsInfo = [];
  var fabbox2ItemsId = [];
  var fabbox2ItemsQty = [];
  $('.cart-right.cart-right-fabbox-2 div.added-cart:visible').each(function() {
    var tempId = $(this).data('id');
    var tempQty = $(this).find('.title').text();
    var indexOfQty = tempQty.indexOf(' X ');

    if (indexOfQty != -1) {
    	if (tempId == surpriseProductID)
          tempQty = tempQty.charAt(indexOfQty+3);
      	else
          tempQty = tempQty.charAt(indexOfQty+4);
    } 
    else
      tempQty = 1;
    
    fabbox2ItemsInfo.push(tempId + ':' + tempQty );
    fabbox2ItemsId.push(tempId);
    fabbox2ItemsQty.push(tempQty);
  });
  console.log('addedItems2: ' + fabbox2ItemsInfo);
  localStorage.fabbox2ItemsId = fabbox2ItemsId;
  localStorage.fabbox2ItemsQty = fabbox2ItemsQty;
}

function clearStroeFabboxItemsInfo() {
  // Fabbox-1
  localStorage.fabbox1ItemsId = '';
  localStorage.fabbox1ItemsQty = '';
  // Fabbox-2
  localStorage.fabbox2ItemsId = '';
  localStorage.fabbox2ItemsQty = '';
  console.log('clearStroeFabboxItemsInfo');
}


function loadFabbox1_2Items () {

  if (typeof localStorage.fabbox1ItemsId != 'undefined' && localStorage.fabbox1ItemsId != '' && 
      typeof localStorage.fabbox2ItemsId != 'undefined' && localStorage.fabbox2ItemsId != '') {
    var fabbox1Qty = arraySum(localStorage.fabbox1ItemsQty);
    var fabbox2Qty = arraySum(localStorage.fabbox2ItemsQty);
    var fabboxQty = fabbox1Qty+fabbox2Qty;
    // check shopift cart and stored cart info are equal
    if(cartCount > 5 && cartCount == fabboxQty) {
      // Check is box 1 & 2 have any same product(s)
      for (var i = 0; i < localStorage.fabbox1ItemsId.length; i++) {
        for (var j = 0; j < localStorage.fabbox2ItemsId.length; j++) {
          if (localStorage.fabbox1ItemsId[i] == localStorage.fabbox2ItemsId[j]) {
            console.log('box 1 & 2 have one/more same product(s)');
            loadFabbox1ItemsFromStorage();
            loadFabbox2ItemsFromStorage();
            return false; // break
          }
        }
      }
    }
    // clear the cart when stored cart info diff from shopify cart info
    else if (cartCount == fabboxQty) {
      $('.empty-cart').click();
      console.log('empty cart triggered');
    }
   } 
}


function loadFabbox1ItemsFromStorage() {
  var box1IDs = localStorage.fabbox1ItemsId.split(',');
  var box1Qty = localStorage.fabbox1ItemsQty.split(',');
  // clear the li as initial
  $('.cart-right-fabbox-1 li').each(function() {
    $(this).css('display', 'block');
	$(this).find('.added-cart').remove();
  });
  
  var eleIndex = 0;
  $.each(box1IDs, function (index, value) {
    var parentEle = $(".product-middle-part ul").find("[data-id='" + value + "']").parent('li');
    if(value == surpriseProductID) {
      var title = 'Surprise snack';
      var img = surpriseProductImgURL;
    }
    else{
      var title = parentEle.find('.title').html();
      var img = parentEle.find('.product-img').attr('src');
    }
    var html = create_li(value, box1Qty[index], title, img);
    
    var parentEle = $('.cart-right-fabbox-1 li').eq(eleIndex);
        parentEle.append(html);
        parentEle.find(".note-pick").addClass('hide');
        for(i=0; i<box1Qty[index]-1; i++) {
          eleIndex++;
          console.log('iteration: ' + eleIndex);
          var currentEle = $('.cart-right-fabbox-1 li').eq(eleIndex);
          currentEle.append(html);
          currentEle.find(".note-pick").addClass('hide');
          currentEle.css('display', 'none');
        }   
    eleIndex++;	
  });
}

function loadFabbox2ItemsFromStorage() {
  var box2IDs = localStorage.fabbox2ItemsId.split(',');
  var box2Qty = localStorage.fabbox2ItemsQty.split(',');
  // clear the li as initial
  $('.cart-right-fabbox-2 li').each(function() {
    $(this).css('display', 'block');
	$(this).find('.added-cart').remove();
  });
  
  var eleIndex = 0;
  $.each(box2IDs, function (index, value) {
    var parentEle = $(".product-middle-part ul").find("[data-id='" + value + "']").parent('li');
    if(value == surpriseProductID) {
      var title = 'Surprise snack';
      var img = surpriseProductImgURL;
    }
    else{
      var title = parentEle.find('.title').html();
      var img = parentEle.find('.product-img').attr('src');
    }
    var html = create_li(value, box2Qty[index], title, img);
    
    var parentEle = $('.cart-right-fabbox-2 li').eq(eleIndex);
        parentEle.append(html);
        parentEle.find(".note-pick").addClass('hide');
        for(i=0; i<box2Qty[index]-1; i++) {
          eleIndex++;
          console.log('iteration: ' + eleIndex);
          var currentEle = $('.cart-right-fabbox-2 li').eq(eleIndex);
          currentEle.append(html);
          currentEle.find(".note-pick").addClass('hide');
          currentEle.css('display', 'none');
        }   
    eleIndex++;	
  });
}


function create_li (itemId, qty, title, img) {
  var html = $("#cart_template").val();
  if(qty > 1)
    html = html.replace("#itemID#", itemId).replace("#ID#", itemId).replace("#TITLE#", title + '<span class="item-multi"> X </span> <span class="item-title-qty">' + qty + '</span>').replace("#IMG#", img).replace("#QTYADDED#", qty);
  else
    html = html.replace("#itemID#", itemId).replace("#ID#", itemId).replace("#TITLE#", title).replace("#IMG#", img).replace("#QTYADDED#", qty);
    
  return html;
//   console.log(html);
}


function arraySum(arrayVar) {
  var total = 0;
  for (var i = 0; i < arrayVar.length; i++) {
	total += arrayVar[i] << 0;
  }
  return total;
}


function emptySingleBox () {
  $('.fabbox-1-text, .fabbox-2-text').addClass('disabled');
  
  if (!$('.cart-right-fabbox-1 li').hasClass('hide'))
  	var emptyFabbox = $('.cart-right-fabbox-1');
  else 
    var emptyFabbox = $('.cart-right-fabbox-2');
  console.log(emptyFabbox.attr('class'));
  
  var removeEle ;
  emptyFabbox.find('li:visible').each(function(index) {
    if ($(this).find('.added-cart').length) {
      $(this).find('.added-cart .remove').click();
      return false;
    }
  });
  
  if(emptyFabbox.find('li:visible .added-cart').length)
  	setTimeout(emptySingleBox, 500);
  else 
    $('.fabbox-1-text, .fabbox-2-text').removeClass('disabled');
}



// function emptySingleBox() {
//   if (!$('.cart-right-fabbox-1 li').hasClass('hide'))
//   	var emptyFabbox = $('.cart-right-fabbox-1');
//   else 
//     var emptyFabbox = $('.cart-right-fabbox-2');
//   console.log(emptyFabbox.attr('class'));
  
  
//   emptyFabbox.find('li:visible .added-cart').each(function(index) {
//   	console.log('li');
//     var removeEle = $(this).find('.remove');
// //     removeEle.click();  
//     var itemQty = removeEle.data('qty');
//     var delayTime = 0;
//     for(var i=0; i<itemQty; i++) {
//       console.log(delayTime);
//       removeEle.delay(delayTime).trigger("click");
//       delayTime = delayTime + 5000;
//       console.log('li remove');
//     }
//   });
  
// //   var li_count = emptyFabbox.find('li:visible .added-cart').length;
// //   if (li_count) {
// //     console.log('iteration called');
// //     emptySingleBox();
// //   }
// }


function add5Surprise() {
  // Clear cart
  $.post('/cart/clear.js', addSurprise2Cart, 'json');
  
  // Add 5 surprise snack
  function addSurprise2Cart() {
  	$.post('/cart/add.js', {
      quantity: 5,
      id: surpriseProductID
    }, function(data) {
      window.location.href = "/products/get-your-snackbox-2";
    }, 'json');
  }
}


function back2GYB() {
    console.log('selectRegularBox: '+localStorage.selectRegularBox);
  	if(localStorage.selectRegularBox == 'true') {
      $('.box-button-radio input[type="radio"][data-snacktype="2"]').prop('checked', true);
      $('.cust-blur').hide();
      $('html, body').stop().animate({
        scrollTop: $("#snacktype-2-target").offset().top
      }, 1000);
      localStorage.selectRegularBox = false;
      console.log('regular box selected');
      console.log('selectRegularBox: '+localStorage.selectRegularBox);
    }
  follow_Screen();
}